import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { dialogModes, categoryInitialState } from '../Constants';
import { addCategory, updateCategory } from './therapeuticCategoryServices';

function TherapeuticAreaDialog({
  isDialogOpen,
  toggleDialog,
  dialogMode,
  categoryToEdit,
  changeDialogMode,
  setCategoryToEdit,
  addNewCategory,
  editCategory,
}) {
  useEffect(() => {
    if (categoryToEdit) setNewCategory(categoryToEdit);
  }, [categoryToEdit]);

  const [newCategory, setNewCategory] = useState(
    categoryToEdit ? categoryToEdit : categoryInitialState
  );

  const updateCategory = (propName, propValue) => {
    const therapeuticArea = { ...newCategory };
    therapeuticArea[propName] = propValue;
    setNewCategory(therapeuticArea);
  };

  const onAddNewCategory = () => {
    addNewCategory(newCategory, () => {
      setNewCategory(categoryInitialState);
      toggleDialog(false);
    });
  };

  const onEditCategory = () => {
    editCategory(newCategory, () => {
      setNewCategory(categoryInitialState);
      toggleDialog(false);
      changeDialogMode(dialogModes.add);
      setCategoryToEdit(null);
    });
  };

  const upsertCategory = () =>
    dialogMode === dialogModes.add ? onAddNewCategory() : onEditCategory();

  const cancelUpsert = () => {
    setNewCategory(categoryInitialState);
    changeDialogMode(dialogModes.add);
    setCategoryToEdit(null);
    toggleDialog(false);
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogTitle>{`${
        dialogMode === dialogModes.add ? 'Add new' : 'Update'
      } Therapeutic Area`}</DialogTitle>
      <DialogContent>
        <Grid container style={{ flexGrow: 1 }} justify="center">
          <TextField
            id="name"
            label="Therapeutic category name"
            variant="outlined"
            fullWidth
            style={{ marginBottom: '16px' }}
            value={newCategory.name}
            onChange={e => updateCategory('name', e.target.value)}
            autoFocus
            required
            error={!newCategory.name}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!newCategory.name}
          variant="outlined"
          color="primary"
          onClick={upsertCategory}
        >
          {dialogMode === dialogModes.add ? 'Add' : 'Update'}
        </Button>
        <Button variant="outlined" onClick={cancelUpsert} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapDispatchToProps = dispatch => ({
  addNewCategory: (category, cb) => dispatch(addCategory(category, cb)),
  editCategory: (category, cb) => dispatch(updateCategory(category, cb)),
});

export default connect(null, mapDispatchToProps)(TherapeuticAreaDialog);



// WEBPACK FOOTER //
// ./src/therapeuticCategory/CategoryUpsert.js